// Curated 12-color palette, one distinct hue per slot. Ordering is deliberately
// *not* around the color wheel — each entry sits ~180° from its neighbors so that
// two users with adjacent hashes get maximally different colors, not adjacent hues.
// All colors are readable on both the pure-black dark bg and the navy light bg.
const USER_COLOR_PALETTE = [
  "#ef4444", // red
  "#06b6d4", // cyan
  "#eab308", // yellow
  "#8b5cf6", // violet
  "#22c55e", // green
  "#ec4899", // pink
  "#3b82f6", // blue
  "#f97316", // orange
  "#14b8a6", // teal
  "#d946ef", // fuchsia
  "#a3e635", // lime
  "#818cf8", // indigo
];

export const getUserColor = (userId: number | null | undefined): string => {
  if (userId == null) return USER_COLOR_PALETTE[0];
  return USER_COLOR_PALETTE[Math.abs(userId) % USER_COLOR_PALETTE.length];
};
